<template>
  <v-dialog v-model="show" max-width="950px" persistent v-if="localInstaller">
    <v-card>
      <v-card-title>
        <div>
          <h3>
            {{ $t("Generic.Create") }}
            {{ $t("Manage_Installers.Installer") }}
          </h3>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click.native="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-3"></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid">
                <v-text-field
                  :label="$t('Generic.Name')"
                  v-model="localInstaller.name"
                  :rules="[v => !!v || $t('Rules.Name_required')]"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-on:click="show = false">{{ $t("Generic.Cancel") }}</v-btn>
        <v-btn
          text
          :color="'green'"
          :disabled="!valid"
          v-on:click="createInstaller"
          >{{ $t("Generic.Create") + " " + localInstaller.name }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      localInstaller: undefined,
      valid: false
    };
  },
  props: {
    value: Boolean
  },
  methods: {
    createInstaller() {
      if (this.$refs.form.validate()) {
        this.$emit("create-installer", this.localInstaller);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.localInstaller = {
          name: ""
        };
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
